// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3Wf3f","detailsBorder":"styles_detailsBorder__1sDbc"};